// removed by extract-text-webpack-plugin
module.exports = {"block":"TopMenuBalance__block-31J-q","icon":"TopMenuBalance__icon-1AkWe","balance":"TopMenuBalance__balance-2AkTs"};